import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Holding } from '@/api/holdings';
import { ConfirmDialog } from '@/components/ConfirmDialog';

interface DisposeHoldingDialogProps {
  holding: Holding;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

export function DisposeHoldingDialog({ holding, onClose, onConfirm }: DisposeHoldingDialogProps) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleConfirm() {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await onConfirm();
    } catch {
      setError(t('holdings.errorGeneric'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <ConfirmDialog
      title={t('holdings.disposeConfirm', { name: holding.name })}
      consequence={t('holdings.disposeBody')}
      confirmLabel={t('holdings.dispose')}
      destructive
      busy={busy}
      error={error}
      onConfirm={() => void handleConfirm()}
      onCancel={onClose}
    />
  );
}
